import React from "react";
import LoginSidebar from "./LoginSidebar";
import Button from "../../shared/form/Button";

const Login = props => {
    return (
        <div className="row">
            <div className="col-sm-8">
                <div className="island donor-login">
                    <h2>Welcome! Please sign in to your account below</h2>

                    <form autoComplete="off" method="post" onSubmit={props.handleSubmit}>
                        <div className="form-item">
                            <label htmlFor="edit-name">
                                Username
                                <span
                                    className="form-required"
                                    title="This field is required."
                                >
                                    *
                                </span>
                            </label>
                            <input
                                onChange={props.handleChange}
                                value={props.user.username}
                                type="text"
                                id="edit-name"
                                name="email"
                                size="15"
                                maxLength="60"
                                className="form-control"
                                autoComplete="off"
                            />
                        </div>

                        <div className="form-item">
                            <label htmlFor="edit-pass">
                                Password
                                <span
                                    className="form-required"
                                    title="This field is required."
                                >
                                    *
                                </span>
                            </label>
                            <input
                                onChange={props.handleChange}
                                value={props.user.password}
                                type="password"
                                id="edit-pass"
                                name="password"
                                size="15"
                                maxLength="128"
                                className="form-control"
                                autoComplete="off"
                            />
                        </div>

                        <p>
                            <a
                                href="/forgotpassword"
                                title="Request new password via e-mail."
                            >
                                Forgot your password?
                            </a>
                        </p>

                        <Button loading={props.loading}>Login</Button>
                    </form>

                    <div className="log-in-instructions">
                        <h3>Unable to Sign In?</h3>
                        <p>
                            Contact us at{" "}
                            <a href="mailto:wv_phil@wvi.org">wv_phil@wvi.org</a>{" "}
                            or call (+632) 8372 7777
                        </p>
                    </div>
                </div>

                <div className="island">
                    <p>
                        By logging in to the portal, you agree to keep the
                        details about your sponsored child confidential and not
                        for public posting.
                    </p>
                    <p>
                        Click here for more information regarding our{" "}
                        <a href="https://www.worldvision.org.ph/privacy-notice/" rel="noopener noreferrer">
                            Data Privacy Notice
                        </a>
                        .
                    </p>
                </div>
            </div>

            <div className="col-md-4">
                <LoginSidebar />
            </div>
        </div>
    );
};

export default Login;
